import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMPassword from "src/components/UI/atoms/formFields/ATMPassword/ATMPassword";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import useBranches from "src/hooks/useGetBranches";
import useRoles from "src/hooks/useRoles";
import { UserFormValues } from "src/models/User.model";
import { handleValidNumber } from "src/utils/validations/numberInput";

type Props = {
  formikProps: FormikProps<UserFormValues>;
  onClose: () => void;
  formType: "Add" | "Edit";
};

const UserForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { branches } = useBranches()
  const { roles, isDataLoading } = useRoles();

  const rolesOptions = roles?.map((role) => {
    return {
      label: role?.userRoleName,
      value: role?.userRoleName,
    };
  });
  const branchOptions = branches?.map((branch) => {
    return {
      label: branch?.branchName,
      value: branch?._id
    }
  })

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> {formType} User </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* First Name */}
        <div className="">
          <ATMTextField
            name="firstName"
            value={values.firstName}
            onChange={(e) => setFieldValue("firstName", e.target.value)}
            label="First Name"
            placeholder="Enter First Name"
            onBlur={handleBlur}
          />
        </div>
        {/* Last Name */}
        <div className="">
          <ATMTextField
            name="lastName"
            value={values.lastName}
            onChange={(e) => setFieldValue("lastName", e.target.value)}
            label="Last Name"
            placeholder="Enter Last Name"
            onBlur={handleBlur}
          />
        </div>
        {/* Username */}
        <div className="">
          <ATMTextField
            name="userName"
            value={values.userName}
            onChange={(e) => setFieldValue("userName", e.target.value)}
            label="Username"
            placeholder="Enter Username"
            onBlur={handleBlur}
          />
        </div>
        {/* Mobile */}
        <div className="">
          <ATMTextField
            name="mobile"
            value={values.mobile}
            onChange={(e) =>
              handleValidNumber(e) && setFieldValue("mobile", e.target.value)
            }
            label="Mobile"
            placeholder="Enter Mobile"
            onBlur={handleBlur}
          />
        </div>
        {/* Email */}
        <div className="">
          <ATMTextField
            name="email"
            value={values.email}
            onChange={(e) => setFieldValue("email", e.target.value)}
            label="Email"
            placeholder="Enter Email"
            onBlur={handleBlur}
          />
        </div>
        {/* Password */}
        <div className="" hidden={formType === "Edit"}>
          <ATMPassword
            name="password"
            value={values.password}
            onChange={(e) => setFieldValue("password", e.target.value)}
            label="Password"
            placeholder="Enter Password"
            onBlur={handleBlur}
          />
        </div>
        {/* Role */}
        <div className="">
          <ATMSelect
            name="userRole"
            value={values.userRole}
            isLoading={isDataLoading}
            onChange={(newValue) => {
              setFieldValue("userRole", newValue);
            }}
            label="Role"
            placeholder="Select Role"
            options={rolesOptions}
          />
        </div>
        {/* Branch */}
        <div className="">
          <ATMMultiSelect
            name="branches"
            value={values.branches}
            isLoading={false}
            onChange={(newValue) => {
              setFieldValue("branches", newValue);
            }}
            label="Branch"
            placeholder="Select Branch"
            options={branchOptions}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default UserForm;
